import React from "react"
import PropTypes from "prop-types"
import { Button } from "react-bootstrap"
import Icon from "app/static/frontend/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"
import { helpTexts } from "app/static/frontend/sheets/components/helpTexts"

// Render the Email All button for sheets
export const EmailAllButton = ({ onClick, style }) => (
    <Tooltip label={helpTexts.email_all.tooltip}>
        <Button
            data-cy="email-all-from-sheet-button"
            className={"sheets-buttons"}
            onClick={onClick}
            style={style}
            variant="default"
        >
            {<Icon name="envelope" />} {helpTexts.email_all.buttonText}
        </Button>
    </Tooltip>
)

EmailAllButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    emailAllParams: PropTypes.object.isRequired,
}

export default EmailAllButton
